<template>
    <div>
        <div
            v-if="visibleModal === modalName"
            :class="isLoading ? 'bg-opacity-75 backdrop-blur-xs' : 'bg-opacity-25'"
            class="fixed top-0 z-20 flex h-screen w-screen bg-black outline-none"
            tabindex="0"
            @keyup.enter.stop="validate()"
            @keyup.stop="cancel($event)"
        >
            <!-- Loader-->
            <div
                v-if="isLoading"
                class="absolute inset-1/2 z-40 -ml-5"
            >
                <MyLoader
                    :class="classStyles['text-main_color-600']"
                    size-icon="lg"
                ></MyLoader>
            </div>

            <div
                v-click-outside="closeModal"
                :class="[
          styles.card,
          { 'animate__animated animate__fadeInDown': anim },
          classStyles['divide-main_color-700'],
          { 'blur-xs': isLoading }
          ]"
                class="m-auto max-h-full w-full divide-y-4 divide-double overflow-y-auto bg-scroll py-4 sm:w-11/12 md:w-3/4 xl:w-2/3"
            >
                <div class="mb-4 flex items-center justify-between">
                    <BaseH2>{{ title }}</BaseH2>
                    <slot name="actions"></slot>
                </div>

                <div>
                    <slot/>
                </div>
                <div class="xs:flex-row-reverse mt-2 flex flex-col items-center pt-3">
                    <div
                        class="mx-auto sm:m-0"
                        @click="validate()"
                    >
                        <slot name="validate"></slot>
                    </div>
                    <div
                        class="xs:mt-0 mx-auto mt-2 sm:ml-0 sm:mr-2"
                        @click="closeModal()"
                    >
                        <BaseButtonSimple
                            color-type="secondary"
                        >
                            {{ cancelText }}
                        </BaseButtonSimple>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapWritableState } from 'pinia'

import useGenericStore from '../../common/store/generic'
import MyLoader from '../MyLoader'
import BaseButtonSimple from './Buttons/BaseButtonSimple'
import BaseH2 from './Titles/BaseH2'

export default {
  name: 'BaseModal',
  components: {
    BaseH2,
    BaseButtonSimple,
    MyLoader
  },

  props: {
    modalName: {
      type: String,
      required: true
    },

    title: {
      String,
      required: true
    },

    cancelText: {
      type: String,
      default: 'Annuler'
    },

    confirmActionReturn: String
  },

  data () {
    return {
      styles: window.myStyles,
      anim: window.anim,
      classStyles: window.class_styles,
      isLoading: false
    }
  },

  methods: {
    validate () {
      this.isLoading = true
      const confirmAction = this.$listeners['confirm-action']
      if (this.confirmActionReturn === 'promise') {
        confirmAction().then(this.hideModal, _ => {
          this.isLoading = false
        })
      } else if (this.confirmActionReturn !== 'redirect') {
        confirmAction()
        this.hideModal()
      } else confirmAction()
    },

    cancel (e) {
      switch (e.key) {
        case 'Escape':
        case 'Backspace':
        case 'ArrowLeft':
          this.closeModal()
      }
    },

    closeModal () {
      this.isLoading = true
      if (this.$listeners && typeof this.$listeners.cancel === 'function') {
        if (this.$listeners.cancel() !== 'isRedirection') this.hideModal()
      } else this.hideModal()
    },

    hideModal () {
      this.visibleModal = null
      this.$root.focusStep()
      this.isLoading = false
    }
  },

  computed: {
    ...mapWritableState(useGenericStore, ['visibleModal'])
  },

  watch: {
    visibleModal: {
      handler (newVal) {
        if (newVal === this.modalName) this.$nextTick(_ => this.$el.focus())
      },
      immediate: true
    }
  }
}
</script>

<style scoped>

</style>
